module.exports = __webpack_public_path__ + "img/cr.62626541.svg";